import { render, staticRenderFns } from "./add-vehicle-owner-info-modal.vue?vue&type=template&id=71257e52&"
import script from "./add-vehicle-owner-info-modal.vue?vue&type=script&lang=js&"
export * from "./add-vehicle-owner-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports